// AUTO-GENERATED by build-sfx-sprite.js — do not edit manually
// Run "npm run build:sfx" to regenerate
export const SFX_SPRITE_MAP = {
  "big_win": [
    0,
    3737.0748299319725
  ],
  "button_click": [
    5000,
    128.84353741496568
  ],
  "epic_win": [
    7000,
    3737.0521541950106
  ],
  "expanding_wild": [
    12000,
    2169.229024943311
  ],
  "mega_win": [
    16000,
    3737.0521541950125
  ],
  "reel_stop": [
    21000,
    92.06349206349174
  ],
  "scatter_1": [
    23000,
    1234.5578231292507
  ],
  "scatter_2": [
    26000,
    1234.5578231292507
  ],
  "spin": [
    29000,
    128.84353741496568
  ],
  "super_win": [
    31000,
    3737.0521541950125
  ],
  "wild": [
    36000,
    1234.5578231292507
  ],
  "win": [
    39000,
    2001.9954648526052
  ],
  "win_music_end": [
    43000,
    3555.555555555557
  ]
};
